<template>
  <div class="p-hs">
    <div class="p-hs-tit">
      <div class="title">{{baseData.title}}</div>
      <div class="subtitle">{{baseData.subtitle}}</div>
    </div>
    <div class="p-hs-box">
      <img class="imgs" :src="supportWebp ? baseData.icon : baseData.pngIcon" alt="">
      <div
        class="li"
        v-for="(item, i) in baseData.introduceList"
        :key="i"
      >
        <img :src="supportWebp ? baseData.icon : baseData.pngIcon" alt="icon" class="li-icon">
        <div class="li-box">
          <p class="title">{{item.title}}</p>
          <p class="desc" v-html="item.desc"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {secureData} from '../config'
export default {
  name: 'work-component',
  data () {
    return {
      baseData: secureData,
      supportWebp: localStorage.isSupportWebp === 'true'
    }
  }

}
</script>

<style lang="scss" scoped>
.p-hs{
  width: 1200px;
  margin: 0 auto;
  min-height: 768px;
  padding-bottom: 32px;
  @media screen and (max-width: $width-l) {
    width: 100%;
    padding: 0 32px 32px 32px;
  }
  &-tit{
    height: 176px;
    text-align: center;
    padding-top: 56px;
    .title{
      font-weight: 700;
      font-size: 36px;
      line-height: 48px;
      text-align: center;
      color: rgba(13, 13, 13, 0.9)
    }
    .subtitle{
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      color: rgba(13, 13, 13, 0.66);
      margin-top: 16px;
    }
  }
  &-box{
    position: relative;
    margin-top: 76px;
    @include responsive($width-s) {
      margin-top: 0px;
    }
    .imgs{
      position: absolute;
      width: 610px;
      height: 500px;
      top: 50%;
      right: 0px;
      transform: translate(0, -50%);
      @include responsive($width-l) {
        width: 50%;
        height: auto;
      }
      @include responsive($width-m) {
        width: 50%;
        height: auto;
      }
      @include responsive($width-s) {
        width: 100%;
        height: auto;
        position: static;
        transform: translate(0, 0);
      }
    }
    .li{
      width: 506px;
      height: 120px;
      position: relative;
      display: flex;
      @include responsive($width-l) {
        width: 45%;
        height: auto;
      }
      @include responsive($width-m) {
        width: 45%;
        height: auto;
      }
      @include responsive($width-s) {
        width: 100%;
        height: auto;
      }
      & + .li{
        margin-top: 24px;
      }
      &-icon{
        width: 60px;
        height: 60px;
        flex-shrink: 0;
        margin-right: 24px;
      }
      &-box{
        padding-top: 16px;
        .title{
          font-weight: 600;
          font-size: 20px;
          line-height: 32px;
          color: rgba(13, 13, 13, 0.9);
        }
        .desc{
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          color: rgba(13, 13, 13, 0.66);
          margin-top: 12px;
        }
      }
    }
  }
}
</style>
